import React, { useContext } from 'react';
import { ThemeContext } from '../../ContextProvider/ThemeContext';
import styles from './Experiences.module.css';

const experiencesData = [
  {
    title: "Software Developer - 3 | Intranet Solution",
    company: "Zaptas Technologies",
    companyLink: "https://www.zaptas.com/",
    date: "Sept 2024 - Present",
    responsibilities: [
      "Independently designed and developed a company-wide Intranet solution, leveraging React.js, Node.js, Redis, and AWS (EC2, S3) for scalable, high-performance architecture.",
      "Implemented SSO (Single Sign-On) authentication and session management to enhance security and streamline user experience.",
      "Optimized data flow and caching mechanisms with Redis, improving system performance and user access times.",
      "Ensured high availability, fault tolerance, and secure data handling using AWS services and automated deployments.",
      "Delivered a responsive and intuitive UI/UX for internal users, enhancing collaboration and productivity.",
    ],
    liveLink: "https://intranet.zaptas.in/",
  },
  {
    title: "Software Developer - 2 | Dialer System",
    company: "Radical Minds Technologies",
    companyLink: "https://rmtengg.com/",
    date: "Nov 2022 - Aug 2024",
    responsibilities: [
      "Developed and optimized a Dialer system (OptiML) with SIP integration using Node.js, Express.js, and MongoDB, improving call efficiency by 25%.",
      "Built scalable, secure, and efficient RESTful APIs and microservices, deployed using AWS EC2 and IAM roles.",
      "Architected data storage solutions using AWS S3 for efficient data retrieval and backup.",
      "Integrated Asterisk dialer API for seamless call operations and real-time monitoring using AWS CloudWatch.",
      "Utilized Agile methodologies for continuous delivery and timely project completion.",
    ],
    liveLink: "https://demo.radicalminds.in/",
  },
  {
    title: "Node.js Developer | Logistics Tracking",
    company: "Trames Private Limited",
    companyLink: "https://trames.io/",
    date: "May 2022 - Dec 2022",
    responsibilities: [
      "Developed backend infrastructure for a logistics tracking platform using Node.js, Express.js, and AWS Lambda.",
      "Designed and implemented RESTful APIs for real-time data communication, improving efficiency and reducing latency.",
      "Worked with AWS IAM to secure APIs and ensured best practices in data security.",
      "Deployed static assets using AWS S3 and CloudFront to optimize website performance.",
      "Collaborated using Agile practices to meet project deadlines and client requirements.",
    ],
    liveLink: "",
  },
];

const Experiences = () => {
  const { newTheme } = useContext(ThemeContext);

  return (
    <div className={styles.experiences}>
      <h1 style={{ color: `${newTheme.title}` }} className={styles.heading}>
        Experience
      </h1>
      <div className={styles.borderBottom} />

      {experiencesData.map((experience, index) => (
        <div key={index} className={styles.container}>
          <div className={styles.position}>
            {experience.title}{' '}
            <a href={experience.companyLink} target="_blank" rel="noopener noreferrer">
              @ {experience.company}
            </a>
          </div>
          <div className={styles.date}>{experience.date}</div>
          
          {/* Live Link Right Above the Responsibilities */}
  
          
          <fieldset className={styles.responsibilites}>
            <legend>
              <h3>Roles & Responsibilities</h3>
            </legend>
            <ul>
            {experience.liveLink && (
            <div className={styles.liveLink}>
              <strong>Live Link: </strong>
              <a href={experience.liveLink} target="_blank" rel="noopener noreferrer">
                {experience.liveLink}
              </a>
              <hr/>
            </div>
            
          )}
       
              {experience.responsibilities.map((responsibility, index) => (
                <li key={index}>{responsibility}</li>
              ))}
            </ul>
          </fieldset>
        </div>
      ))}
    </div>
  );
};

export default Experiences;
